<app-splash-screen></app-splash-screen>

@switch (pageLayoutService.layout$ | async) {
  @case (PageLayout.Authorized) {
    <div class="app-container">
      <app-authorized-layout class="app-container">
        <app-loader></app-loader>
        <router-outlet />
      </app-authorized-layout>
    </div>
  }
  @case (PageLayout.UnAuthorized) {
    <div class="app-container">
      <app-unauthorized-layout>
        <app-loader></app-loader>
        <router-outlet />
      </app-unauthorized-layout>
    </div>
  }
  @case (PageLayout.UnAuthenticated) {
    <app-loader></app-loader>
    <router-outlet />
  }
  @default {
    <app-loader></app-loader>
    <router-outlet />
  }
}

<app-toast [type]="toastType" [show]="showToast">
  {{ message }}
</app-toast>

<app-achievement-unlock-modal></app-achievement-unlock-modal>

<app-report-content-modal
  [isOpen]="isReportPopupOpen"
></app-report-content-modal>

<app-access-denied-modal></app-access-denied-modal>
